import { ProjectMember } from '@ih/app/shared/apis/interfaces';

export class FindAllProjectPermissionsAction {
  public static readonly type =
    '[Authorisation] FindAllProjectPermissionsAction';
  constructor(public readonly projectMembers: ProjectMember[]) {}
}
